import { useListPager } from '@airship-platform/airship-patterns';
import { EmptyState, FlexBox } from '@airship-platform/jam-web/components';
import { ProposalTemplateTag } from '@airship-platform/airship-proposal';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { Fragment, useState } from 'react';
import { ProposalTemplateOption } from '../../../data-access/proposalTemplate';
import ProposalTemplateOptionCard from './ProposalTemplateOptionCard';

type ProposalTemplateOptionQueryResultsProps = {
  proposalTemplateTags: ProposalTemplateTag[];
  proposalTemplateOptions: ProposalTemplateOption[];
};

const ProposalTemplateOptionQueryResults: React.FC<
  ProposalTemplateOptionQueryResultsProps
> = ({ proposalTemplateTags, proposalTemplateOptions }) => {
  const [pageCounter, setPageCounter] = useState(20);

  const { loaderRef } = useListPager({
    incrementBy: 20,
    initialValue: pageCounter,
    maxValue: proposalTemplateOptions.length,
    callbackFn: setPageCounter,
  });

  const pagedOptions = proposalTemplateOptions.slice(0, pageCounter);

  if (!proposalTemplateOptions.length) {
    return (
      <EmptyState
        title="No templates found"
        subtitle={'Please adjust your filters.'}
      />
    );
  }

  return (
    <FlexBox flexDirection={'column'} gap={2} width={'100%'}>
      {pagedOptions.map((option, idx) => (
        <Fragment key={option.proposalTemplateOptionId}>
          <ProposalTemplateOptionCard
            proposalTemplateTags={proposalTemplateTags.filter((tag) =>
              option.tagIds.includes(tag.proposalTemplateTagId)
            )}
            proposalTemplateOption={option}
          />
          {idx < proposalTemplateOptions.length - 1 && (
            <Divider flexItem sx={{ borderColor: 'grey.400' }} />
          )}
        </Fragment>
      ))}
      <Box ref={loaderRef} sx={{ height: 50 }} />
    </FlexBox>
  );
};

export default ProposalTemplateOptionQueryResults;
